interface CSSModule {
  [className: string]: string;
}

export const mapToCssModules = (className = '', cssModule: CSSModule = {}) => {
  if (!cssModule) return className;
  return className
    .split(' ')
    .map(c => cssModule[c] || c)
    .join(' ');
};
